<template>
  <div>
    <DesktopNavbarShadow />
    </div>
  <div>
    <DesktopNavbar class="desktop-bar" />
    <MobileNavbar class="mobile-bar" />
  </div>
</template>

<script>
import DesktopNavbar from './DesktopNavbar.vue';
import MobileNavbar from './MobileNavbar.vue';
import DesktopNavbarShadow from './DesktopNavbarShadow.vue';

export default {
  name: 'AppNavbar',
  components: {
    DesktopNavbar,
    MobileNavbar,
    DesktopNavbarShadow,
  },
};
</script>

<style scoped>
  .desktop-bar {
    position: fixed;
    display: none;
    align-items: center;
  }

  .mobile-bar {
    position: fixed;
    display: none;
    align-items: center;
  }

  @media (min-width: 800px) {
    .desktop-bar {
      display: flex;

    }
  }

  @media (max-width: 800px) {
    .mobile-bar {
      display: flex;
    }
  }
/* Optional: Any additional styling for AppNavbar */
</style>
